import { ref } from 'vue'
import useGet from '@/core/composables/api/useGet'
import usePut from '@/core/composables/api/usePut'
import { ApiRequestStatus } from '@/core/models/api/api-request-status'
import { useSnackStore } from '@/stores/snack.store'

export const useEditDialogSetting = (callback?: () => void) => {
  const snackStore = useSnackStore()
  const { data, status, load } = useGet<DialogSettingResponse>('coaching/dialog-setting')
  const { mutate, status: updateStatus } = usePut<void, UpdateDialogSettingBody>(
    'coaching/dialog-setting/feedback-topics',
  )

  const selectedFeedbackTopicIds = ref<string[]>([])

  const initDialogSetting = async () => {
    await load()
    selectedFeedbackTopicIds.value = extractFeedbackTopicIds(data.value)
  }

  const toggleFeedbackTopic = (feedbackTopicId: string) => {
    if (selectedFeedbackTopicIds.value.includes(feedbackTopicId)) {
      selectedFeedbackTopicIds.value = selectedFeedbackTopicIds.value.filter(
        (id) => id !== feedbackTopicId,
      )
      return
    }

    selectedFeedbackTopicIds.value = [...selectedFeedbackTopicIds.value, feedbackTopicId]
  }

  const updateDialogSetting = async () => {
    if (updateStatus.value === ApiRequestStatus.Loading) {
      return
    }

    await mutate({ feedbackTopicIds: selectedFeedbackTopicIds.value })

    if (updateStatus.value === ApiRequestStatus.Success) {
      snackStore.showInfo('Dialogeinstellungen wurden gespeichert.')
      callback?.()
      return
    }

    if (updateStatus.value === ApiRequestStatus.Error) {
      snackStore.showError('Dialogeinstellungen konnten nicht gespeichert werden.')
    }
  }

  return {
    selectedFeedbackTopicIds,
    status,
    updateStatus,
    initDialogSetting,
    toggleFeedbackTopic,
    updateDialogSetting,
  }
}

const extractFeedbackTopicIds = (response?: DialogSettingResponse): string[] => {
  if (!response) {
    return []
  }

  if (response.feedbackTopicIds) {
    return response.feedbackTopicIds
  }

  return response.dialogSetting?.feedbackTopicIds ?? []
}

interface DialogSettingResponse {
  feedbackTopicIds?: string[]
  dialogSetting?: {
    feedbackTopicIds: string[]
  }
}

interface UpdateDialogSettingBody {
  feedbackTopicIds: string[]
}
